import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../apiClient";

export const getBuses = ({ id, ...params }) => {
  return api.get(`admin/buses-v2`, {
    params,
  });
};

export const getBusesQueryOptions = params => {
  return queryOptions({
    queryKey: ["buses", params],
    queryFn: () => getBuses(params),
  });
};

export const useBusesQuery = ({ queryConfig = {}, ...params }) => {
  return useQuery({
    ...getBusesQueryOptions(params),
    ...queryConfig,
  });
};
